import { Text } from "@smartsuite/react-ui/lib";
import * as S from "./style";
import { observer } from "mobx-react-lite";
import { t } from "i18next";

export const ActivityBadge = observer<{
  onClick: () => void;
}>(({ onClick }) => {
  return (
    <S.Container onClick={onClick}>
      <Text size="s">{t("job-list.History")}</Text>
    </S.Container>
  );
});
